// import { isPreviewing } from '@builder.io/sdk-vue'; // Removed to fix deployment issues

export const PREVIEW_USER = {
  id: 1384,
  nombre: "Usuario",
  apellido: "Preview",
  urlImagen: "https://files.hernancasciari.com/img/usuarios/preview.jpg",
  usarLetraApellido: 0,
  email: "usuario.preview@orsai.org",
  nombreBase: "usuario-preview",
  catesBase: "cine,serie,comunidad,documental,teatro1",
  paisNacimiento: "Argentina",
  anioNacimiento: "",
  fechaNacimiento: "1990-01-01",
  descripcion: "Usuario de prueba para el modo preview",
  direccion: "Avenida Siempreviva 742",
  dirCalle: "Avenida Siempreviva",
  dirNumero: "742",
  dirPisoDepto: "PB A",
  ciudad: "Buenos Aires",
  provincia: "Buenos Aires",
  codigoPostal: "1425",
  pais: "Argentina",
  telefono: "+54 11 1234-5678",
  auxVarchar: "",
  auxTexto: "",
  bio: "Esta es una biografía de ejemplo para el modo preview. Aquí iría una descripción más detallada del usuario.\n",
  tipoIdTributario: "CUIT",
  idTributario: "20-99999999-9",
  tipoDocIdentidad: "DNI",
  docIdentidad: "99999999",
  extra: {
    estudios: "universitarios",
    profesion: "escritor"
  },
  cuentaVerificada: true,
  idSocio: 99999,
  estudios: "universitarios",
  profesion: "escritor",
  estado_civil: "soltero",
  tiene_hijos: "no"
};

export const PREVIEW_STORY = {
  data: {
    id: 99999,
    documentId: "preview-story-id",
    idUsuario: PREVIEW_USER.id,
    cuento: `En la sala de control del Centro Espacial Orsai, María ajustó sus auriculares mientras monitoreaba las señales entrantes. Las pantallas parpadeaban con datos en tiempo real de la primera misión literaria al espacio profundo. El proyecto "Narrativas Estelares" había enviado a doce escritores a la Estación Orbital de Creación Literaria, donde pasarían seis meses escribiendo historias inspiradas en la vastedad del cosmos.\n
    \nA través de la ventana curva de la estación, los escritores contemplaban la Tierra, una canica azul suspendida en el terciopelo negro del espacio. Cada uno había traído consigo un cuaderno análogo y una tablet especialmente diseñada para funcionar en gravedad cero. Las palabras flotaban literalmente en el aire gracias a la tecnología de proyección holográfica.\n
    \nEsa noche, durante la sesión de escritura nocturna, las luces de la aurora boreal danzaban bajo la estación, inspirando nuevos capítulos y tramas inesperadas. En la Tierra, millones de lectores esperaban ansiosamente la transmisión diaria de los fragmentos escritos en órbita, historias que entrelazaban la realidad espacial con la ficción más pura.\n
    \nMaría sonrió al recibir la última transmisión: las historias del espacio estaban cambiando la forma en que la humanidad se veía a sí misma, una palabra a la vez, a 400 kilómetros sobre la superficie terrestre.`,
    titulo: "Narrativas en Órbita",
    resumen: "Una historia sobre el primer programa de residencia literaria en el espacio, donde doce escritores orbitan la Tierra mientras crean nuevas narrativas inspiradas en la perspectiva única que ofrece el cosmos.",
    tema: "De la ciencia ficción y los sueños del futuro",
    audio_v2: null,
    createdAt: "2024-03-20T00:00:00.000Z",
    updatedAt: "2024-03-20T00:00:00.000Z",
    publishedAt: "2024-03-20T00:00:00.000Z",
    cover: "https://files.hernancasciari.com/img/preview-cover.jpg"
  },
  meta: {}
};

export const getPreviewTaller = async (strapiService) => {
  try {
    const response = await strapiService.get('/api/talleres?filters[slug]=taller-demo');
    if (response?.[0]) {
      return response[0];
    }
  } catch (error) {
    console.error('Error obteniendo taller demo:', error);
  }
  
  // Fallback si no se puede obtener el taller demo
  return {
    id: 'demo',
    slug: 'taller-demo',
    titulo: 'Taller Demo',
    docente: 'Hernán Casciari',
    descripcion: 'Taller de demostración',
    agenda: [
      {
        titulo: 'Clase 1',
        fecha: '2024-04-01',
        descripcion: 'Introducción al taller',
        horario: '19:00',
        duracion: '2 horas',
        modalidad: 'virtual'
      },
      {
        titulo: 'Clase 2',
        fecha: '2024-04-08',
        descripcion: 'Desarrollo de personajes',
        horario: '19:00',
        duracion: '2 horas',
        modalidad: 'virtual'
      }
    ]
  };
};